import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { pendingInvite, forgetInvite } from './inviteToken';
import { FiUsers, FiX } from 'react-icons/fi';

// Reminds a signed-in teacher about a school invite they opened earlier
const SchoolInviteBanner = () => {
  const { userProfile } = useAuth();
  const location = useLocation();
  const [token, setToken] = useState(pendingInvite);

  if (!token || location.pathname.startsWith('/join-school') || !userProfile) return null;
  if (userProfile.schoolId) {
    forgetInvite();
    return null;
  }

  return (
    <div className="bg-[#116D6E] text-white px-5 sm:px-8 py-3 flex items-center gap-3 text-sm">
      <FiUsers className="w-4 h-4 flex-none" />
      <span className="flex-1">You have an invite to join a school on TeachESLPro.</span>
      <Link to={`/join-school/${token}`} className="font-semibold underline whitespace-nowrap">Review invite</Link>
      <button
        onClick={() => { forgetInvite(); setToken(null); }}
        aria-label="Dismiss"
        className="w-7 h-7 rounded-md flex items-center justify-center hover:bg-white/10"
      >
        <FiX className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SchoolInviteBanner;
